module.exports = __webpack_public_path__ + "img/yuratchar.4312aa94.jpg";